import { loader } from 'graphql.macro'

export default async function removeSiteFromTicket ({ dataLoaders, variables }) {
  const schema = loader('./removeSiteFromTicket.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, { input: variables })
  return response.removeSiteFromTicket
}
